export default "__VITE_ASSET__C9S5DYKz__"